import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { ProfileService } from '../../services/profile.service';
import { C } from '@angular/cdk/keycodes';
import { CommonServicesForAllModules } from '../../../../shared/common/service';
import { ToastService } from 'src/app/core/toast.service';

// Interfaces
export interface CommunityMember {
  id: string;
  first_name: string;
  last_name: string;
  membership_number: string;
  status: string;
  community_name: string;
  community_id: string;
}

@Component({
  selector: 'app-join-request',
  templateUrl: './join-request.component.html',
  styleUrls: ['./join-request.component.scss']
})
export class JoinRequestComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  // Properties
  loginDetails: any;                 
  filteredUsers: CommunityMember[] = [];       
  selectedTabStatus: string = 'ALL';     
  selectedTabIndex: number = 0;                
  pageSize: number = 10;         
  pageIndex: number = 0;                     
  loading: boolean = false;             
  private fetchSubscription?: Subscription;

  // Constructor
  constructor(
    private profileService: ProfileService,
    private loginService: LoginService,
    private commonservice: CommonServicesForAllModules,
    private toast:ToastService,
  ) {}

  // Lifecycle hooks
  ngOnInit(): void {
     this.loginDetails = this.loginService.getLoginData();
    if (this.loginDetails?.type === 'SUPPLIER') {
      this.fetchCommunityMembers();
    }
  }

  ngOnDestroy(): void {
    this.fetchSubscription?.unsubscribe();
  }

  // Fetch data
  fetchCommunityMembers(): void {
    const supplierId = this.loginDetails?.id;
    if (!this.selectedTabStatus || !supplierId) return;

    const offset = this.pageIndex * this.pageSize;
    this.loading = true;

    // // Temporarily skip ALL tab
    // if (this.selectedTabStatus === 'ALL') return;

    // Cancel previous request
    this.fetchSubscription?.unsubscribe();

    this.fetchSubscription = this.profileService
      .getCommunityMembersByStatus(supplierId ,this.selectedTabStatus, this.pageSize, offset)
      .subscribe({
        next: (data: CommunityMember[]) => {
          if (this.pageIndex === 0) {
            this.filteredUsers = data;
          } else {
            this.filteredUsers = [...this.filteredUsers, ...data];
          }
          console.log("filteredUsers-------------",this.filteredUsers)
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to fetch community members', err);
          this.loading = false;
        }
      });
  }

  // Handle tab changes
  onTabChange(status: string, index: number): void {
    if (this.selectedTabStatus === status) return;
    this.selectedTabStatus = status;
    this.selectedTabIndex = index;
    this.pageIndex = 0;
    this.filteredUsers = [];
    this.fetchCommunityMembers();
  }

//  MatPaginator change event
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchCommunityMembers();
  }

  //  Generic Update Status Function — using refetch (recommended)
  async updatestatus(user: CommunityMember, newStatus: 'APPROVED' | 'REJECTED'): Promise<void> {
    try {
      const fields = { status: newStatus };
      this.loading = true;

      // Update record
      await this.commonservice.UpdateData(Tables.Community_Members, user.id, fields);
      this.toast.openSnackBar(`Member has been ${newStatus.toLowerCase()} successfully.`);
      this.fetchCommunityMembers();
      this.loading = false;
      console.log(`Status updated for ${user.first_name} to ${newStatus}`);
    } catch (error) {
      console.error('Failed to update status:', error);
      this.toast.openSnackBar('Failed to update member status. Please try again.');
      this.loading = false;
    }
  }

}
